import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { RestResponse } from "../../shared/RestResponse";
import { environment } from "../../../environments/environment";

export interface Role {
  id: number;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private readonly baseUrl = `${environment.base_url}/roles`;

  constructor(private http: HttpClient) {}

  list(): Observable<RestResponse<Role[]>> {
    return this.http.get<RestResponse<Role[]>>(`${this.baseUrl}/list`);
  }
}

